import { render } from "./FFXIVMobile.vue?vue&type=template&id=70793aa4&scoped=true"
import script from "./FFXIVMobile.vue?vue&type=script&lang=js"
export * from "./FFXIVMobile.vue?vue&type=script&lang=js"

import "./FFXIVMobile.vue?vue&type=style&index=0&id=70793aa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70793aa4"]])

export default __exports__